import { render, staticRenderFns } from "./MostCoupiedCoupons.vue?vue&type=template&id=0914278d&scoped=true&"
import script from "./MostCoupiedCoupons.vue?vue&type=script&lang=js&"
export * from "./MostCoupiedCoupons.vue?vue&type=script&lang=js&"
import style0 from "./MostCoupiedCoupons.vue?vue&type=style&index=0&id=0914278d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0914278d",
  null
  
)

export default component.exports